import { render, staticRenderFns } from "./admin-permittings.vue?vue&type=template&id=30f3aeca"
import script from "./admin-permittings.vue?vue&type=script&lang=js"
export * from "./admin-permittings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports